function Footer() {
  return (
    <div class="w-full max-w-screen-xl mx-auto p-4 md:py-8 mt-32">
      <span class="block text-sm text-gray sm:text-center">
        © 2023 Space Center. All rights reserved.
      </span>
    </div>
  );
}

export default Footer;
